const ROUTE = {
    LOGIN : '/login',
    REGISTER : '/register',
    ABOUT : '/about',
    DETAIL : '/detail',
    FAVORITES: '/favorites',
    ERROR: '/404',
}

export default ROUTE